/* eslint-disable */
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import BarcoPage from "../pages/Barco";
import DiversionPage from "../pages/Diversion";
import EntretenimientoPage from "../pages/Entretenimiento";
import HomePage from "../pages/Home";
import PaquetesPage from "../pages/Paquetes";
import RelajacionPage from "../pages/Relajacion";
import ServiciosPage from "../pages/Servicios";
import ContactPage from "../pages/Contacto";
import ABordoPage from "../pages/ABordo";
import initI18n from "../lang"; // 👈 importa tu inicialización

initI18n();

function App() {
  const location = useLocation();
  const isMobile = window.innerWidth < 768; // 📱 Detecta móvil

  const sinFondo = [
    "/abordo",
    "/",
    ...(isMobile
      ? ["/relajacion", "/entretenimiento", "/diversion", "/paquetes"]
      : ["/"]),
  ];

  const mostrarFondo =
    !sinFondo.some((path) =>
      path === "/"
        ? location.pathname === "/"
        : location.pathname.startsWith(path)
    ) ||
    (isMobile && location.pathname.startsWith("/servicios"));

  return (
    <div className={mostrarFondo ? "app-background" : ""}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="abordo" element={<ABordoPage />} />
          <Route path="barco" element={<BarcoPage />} />
          <Route path="servicios" element={<ServiciosPage />} />
          <Route path="diversion" element={<DiversionPage />} />
          <Route path="entretenimiento" element={<EntretenimientoPage />} />
          <Route path="relajacion" element={<RelajacionPage />} />
          <Route path="paquetes" element={<PaquetesPage />} />
          <Route path="contacto" element={<ContactPage />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
